import { TranslationModule } from './i18n/translation.module';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { MsgModule } from './message/msg.module';
import { RouterLink } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    TranslationModule,
    MsgModule,
    RouterLink,
    NgIf,
    NgFor,
  ],
  exports: [
    CommonModule,
    TranslationModule,
    MsgModule,
    RouterLink,
    NgIf,
    NgFor,
  ],
})
export class SharedModule {}
